<form formName="cobVerifyOtpForm" [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" class="entry-form">
  <box class="verify-otp-container">
    <box class="verify-otp-banner">
      <img src="./assets/images/sbc/otp-illustrator.svg" alt="verify-otp" />
    </box>

    <box class="form-title-group">
      <div class="header">
      <h2 class="form-title">OTP Verification</h2>
      <!-- <fpx-button *ngIf="_helper.responsive.isHybrid()" className="close" btnType="button" label="close" (onClick)="cOBVerifyOtpFormHelper.closeAlert()"></fpx-button> -->
    </div>
      <p class="form-caption">
        We have sent OTP to registered number {{ state?.mobile }}
      </p>
    </box>


    <fpx-pin [size]="state.pinLength" class="col-mc-12 col-dc-12 col-tc-6 otp" label="" placeholder="OTP Verification"
      formControlName="otp"></fpx-pin>

    <fpx-display-text [ngStyle]="{'display':(formGroup.valid || !state.error)?'none':''}" class="mat-error"
     [innerHTML]="state.error"></fpx-display-text>

    <fpx-timer [hidden]="_helper.hideTimer" class="col-mc-12 col-dc-12 col-tc-6" [startTimer]="state.doStartTimer" [expireSec]="state.timerCount"
      (timeout)="_helper.onTimeout()">
    </fpx-timer>

    <box class="btn-group">
      <fpx-button [disable]="formGroup.invalid || _helper.isFormSubmitted" btnType="submit" className="primary" label="Submit"></fpx-button>
    </box>

    <box class="dont-receive-info-content">
      <p class="info-text">
        Didn't receive the code?
      </p>
      <fpx-button [disable]="_helper.diableResendBtn" className="link" btnType="button" label="Resend code"
        (onClick)="_helper.resendOTP()"></fpx-button>
    </box>

  </box>
</form>